import { render, staticRenderFns } from "./dashboardBox.vue?vue&type=template&id=0520c57a&"
import script from "./dashboardBox.vue?vue&type=script&lang=js&"
export * from "./dashboardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports